import * as z from "zod";

export const debugEmailTemplate = {
  name: "debugEmailTemplate" as const,
  input: z.object({
    templateId: z.string(),
    orderId: z.string().optional(),
    returnId: z.string().optional(),
    format: z.enum(["static", "amp"]),
    forceFallback: z.boolean().optional(),
    fakeTrackingData: z.boolean().optional(),
    forceClickMapDataAttributes: z.boolean().optional(),
  }),
  output: z.string(),
};
